(function () {
  'use strict';

  // Client-side endpoints (browser). Server-side docs use /api/... + private key — do not use in theme.
  var API_REVISION = '2026-04-15';
  var API_CONTENT_TYPE = 'application/vnd.api+json';
  var DIAL_CODES = [
    { iso: 'US', label: 'US +1', code: '1' },
    { iso: 'CA', label: 'CA +1', code: '1' },
    { iso: 'GB', label: 'UK +44', code: '44' },
    { iso: 'AU', label: 'AU +61', code: '61' },
    { iso: 'DE', label: 'DE +49', code: '49' },
    { iso: 'FR', label: 'FR +33', code: '33' },
  ];

  function readConfig() {
    var node = document.getElementById('sx-bis-config');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('[SxKlaviyoBis] Invalid config JSON', error);
      return null;
    }
  }

  function formatE164(dialCode, rawPhone) {
    var digits = String(rawPhone || '').replace(/\D/g, '');
    var code = String(dialCode || '').replace(/\D/g, '');

    if (!code || !digits) return '';

    if (code === '1' && digits.length === 11 && digits.charAt(0) === '1') {
      return '+' + digits;
    }

    if (digits.indexOf(code) === 0 && digits.length > code.length + 6) {
      return '+' + digits;
    }

    return '+' + code + digits;
  }

  function isValidE164(phone) {
    return /^\+[1-9]\d{7,14}$/.test(phone);
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': API_CONTENT_TYPE,
        Accept: API_CONTENT_TYPE,
        revision: API_REVISION,
      },
      body: JSON.stringify(payload),
    }).then(function (response) {
      // Client API returns 202; server API returns 201 — accept both.
      if (response.status === 202 || response.status === 201) {
        return { ok: true };
      }

      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (body) {
          var detail =
            body &&
            body.errors &&
            body.errors[0] &&
            (body.errors[0].detail || body.errors[0].title);

          throw new Error(formatApiError(detail || 'Request failed (' + response.status + ')'));
        });
    });
  }

  function formatApiError(detail) {
    if (/list not found/i.test(detail)) {
      return (
        'SMS List not found. Check Theme settings > Klaviyo > SMS List ID ' +
        '(must be a List ID from Audience > Lists, not a Segment or Form ID).'
      );
    }

    return detail;
  }

  function subscribeBackInStock(companyId, phoneNumber, variantId) {
    return postJson(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
        encodeURIComponent(companyId),
      {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  phone_number: phoneNumber,
                },
              },
            },
            channels: ['SMS'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId,
              },
            },
          },
        },
      }
    );
  }

  function subscribeSmsConsent(companyId, smsListId, phoneNumber) {
    if (!smsListId) {
      return Promise.resolve({ ok: true, skipped: true });
    }

    // Client API: only phone_number in profile — omit subscriptions (defaults to MARKETING).
    // Server-side Subscribe Profiles uses profile.attributes.subscriptions; not valid here.
    return postJson(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' +
        encodeURIComponent(companyId),
      {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  phone_number: phoneNumber,
                },
              },
            },
            custom_source: 'Back in Stock',
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: smsListId,
              },
            },
          },
        },
      }
    );
  }

  class SxKlaviyoBis extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.config = readConfig();
      this.overlay = this.querySelector('.sx-bis-overlay');
      this.form = this.querySelector('.sx-bis-form');
      this.variantSelect = this.querySelector('.sx-bis-variant');
      this.dialCodeSelect = this.querySelector('.sx-bis-dial-code');
      this.phoneInput = this.querySelector('.sx-bis-phone-input');
      this.submitButton = this.querySelector('.sx-bis-submit');
      this.errorMessage = this.querySelector('.sx-bis-message--error');
      this.successMessage = this.querySelector('.sx-bis-message--success');
      this.variantField = this.querySelector('.sx-bis-field--variant');
      this.bodyText = this.querySelector('.sx-bis-body');
      this.dismissButton = this.querySelector('.sx-bis-dismiss');
      this.closeButton = this.querySelector('.sx-bis-close-btn');

      this.populateDialCodes();
      this.bindEvents();
    }

    populateDialCodes() {
      if (!this.dialCodeSelect || !this.config) return;

      var defaultIso = this.config.defaultCountry || 'US';
      this.dialCodeSelect.innerHTML = DIAL_CODES.map(function (item) {
        return (
          '<option value="' +
          item.code +
          '" data-iso="' +
          item.iso +
          '">' +
          item.label +
          '</option>'
        );
      }).join('');

      var matched = DIAL_CODES.find(function (item) {
        return item.iso === defaultIso;
      });
      this.dialCodeSelect.value = matched ? matched.code : '1';
    }

    bindEvents() {
      var self = this;

      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('.sx-bis-trigger');
        if (!trigger) return;

        event.preventDefault();
        event.stopPropagation();

        self.open({
          variantId: trigger.getAttribute('data-variant-id'),
        });
      });

      this.querySelectorAll('[data-sx-bis-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          self.close();
        });
      });

      this.overlay.addEventListener('click', function (event) {
        if (event.target === self.overlay) {
          self.close();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !self.overlay.hidden) {
          self.close();
        }
      });

      if (this.form) {
        this.form.addEventListener('submit', function (event) {
          event.preventDefault();
          self.handleSubmit();
        });
      }
    }

    getOutOfStockVariants() {
      if (!this.config || !Array.isArray(this.config.variants)) return [];

      return this.config.variants.filter(function (variant) {
        return variant && variant.available === false;
      });
    }

    populateVariants(preferredVariantId) {
      var variants = this.getOutOfStockVariants();

      if (!this.variantSelect || !this.variantField) return null;

      if (!variants.length) {
        this.variantField.hidden = true;
        if (this.variantSelect) {
          this.variantSelect.innerHTML = '';
        }
        return preferredVariantId ? String(preferredVariantId) : null;
      }

      this.variantSelect.innerHTML = variants
        .map(function (variant) {
          return (
            '<option value="' +
            variant.id +
            '">' +
            variant.title +
            '</option>'
          );
        })
        .join('');

      this.variantField.hidden = false;
      this.variantSelect.disabled = variants.length === 1;

      var selected =
        variants.find(function (variant) {
          return String(variant.id) === String(preferredVariantId);
        }) || variants[0];

      this.variantSelect.value = String(selected.id);
      return String(selected.id);
    }

    resetMessages() {
      this.errorMessage.hidden = true;
      this.successMessage.hidden = true;
      this.errorMessage.textContent = '';
      this.successMessage.textContent = '';
    }

    open(options) {
      if (!this.config || !this.config.companyId) {
        console.error('[SxKlaviyoBis] Missing Klaviyo company ID');
        return;
      }

      options = options || {};
      this.resetMessages();
      this.form.hidden = false;
      this.submitButton.disabled = false;
      this.activeVariantId = null;

      if (this.bodyText) {
        this.bodyText.hidden = false;
      }
      if (this.dismissButton) {
        this.dismissButton.hidden = false;
      }
      if (this.closeButton) {
        this.closeButton.hidden = true;
      }

      if (this.phoneInput) {
        this.phoneInput.value = '';
      }

      this.activeVariantId = this.populateVariants(options.variantId);
      this.overlay.hidden = false;
      document.body.style.overflow = 'hidden';

      if (this.variantSelect) {
        this.variantSelect.blur();
      }
    }

    close() {
      this.overlay.hidden = true;
      document.body.style.overflow = '';
    }

    showError(message) {
      this.errorMessage.textContent = message;
      this.errorMessage.hidden = false;
      this.successMessage.hidden = true;
    }

    showSuccess(message) {
      this.successMessage.textContent = message;
      this.successMessage.hidden = false;
      this.errorMessage.hidden = true;
      this.form.hidden = true;

      if (this.bodyText) {
        this.bodyText.hidden = true;
      }
      if (this.dismissButton) {
        this.dismissButton.hidden = true;
      }
      if (this.closeButton) {
        this.closeButton.hidden = false;
      }
    }

    handleSubmit() {
      var self = this;
      var variantId =
        this.variantSelect && this.variantSelect.value
          ? this.variantSelect.value
          : this.activeVariantId;

      var phoneNumber = formatE164(
        this.dialCodeSelect.value,
        this.phoneInput.value
      );

      if (!variantId) {
        this.showError('Please select a variant.');
        return;
      }

      if (!isValidE164(phoneNumber)) {
        this.showError('Please enter a valid phone number.');
        return;
      }

      if (!this.config.smsListId) {
        this.showError(
          'SMS List ID is not configured. Set it in Theme settings > Klaviyo.'
        );
        return;
      }

      this.resetMessages();
      this.submitButton.disabled = true;

      subscribeBackInStock(
        this.config.companyId,
        phoneNumber,
        variantId
      )
        .then(function () {
          return subscribeSmsConsent(
            self.config.companyId,
            self.config.smsListId,
            phoneNumber
          );
        })
        .then(function () {
          self.showSuccess(
            self.config.successMessage ||
              "You're in! We'll let you know when it's back."
          );
        })
        .catch(function (error) {
          self.showError(
            (error && error.message) ||
              'Something went wrong. Please try again.'
          );
        })
        .finally(function () {
          self.submitButton.disabled = false;
        });
    }
  }

  function renderNotifyTrigger(variant) {
    var notifyDiv = document.getElementById('notifyDiv');
    var triggerHtml;

    if (!notifyDiv || !variant || !variant.id) {
      return;
    }

    if (variant.available) {
      notifyDiv.innerHTML = '';
      notifyDiv.hidden = true;
      return;
    }

    triggerHtml =
      '<a class="sx-bis-trigger" href="#" data-variant-id="' +
      variant.id +
      '" aria-label="Notify Me When Available">Notify Me When Available</a>';

    notifyDiv.innerHTML = triggerHtml;
    notifyDiv.hidden = false;
  }

  document.addEventListener('variant:change', function (event) {
    renderNotifyTrigger(event && event.detail && event.detail.variant);
  });

  if (!customElements.get('sx-klaviyo-bis')) {
    customElements.define('sx-klaviyo-bis', SxKlaviyoBis);
  }
})();
